var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVoidLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "VoidLine",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.34 19.5",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\n        Void_Line\n    ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M24.81,1.82,23.19.36,21.58,1.82,20,.36,18.35,1.82,16.74.36,15.12,1.82,13.51.36,11.9,1.82,10.28.36,8.67,1.82,7.06.36v19.5L8.67,18.4l1.61,1.46L11.9,18.4l1.61,1.46,1.61-1.46,1.62,1.46,1.61-1.46L20,19.86l1.61-1.46,1.61,1.46,1.62-1.46,1.61,1.46V.36ZM24.27,17H9.21V3.2H24.27Zm-14-4H23.19v2H10.28Zm0-3.9H23.19v1.95H10.28Zm0-3.9H23.19v2H10.28Z",
    transform: "translate(-0.57 -0.36)",
    style: {
      fill: "#757575"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.57,10.11H31.91",
    transform: "translate(-0.57 -0.36)",
    style: {
      fill: "none",
      stroke: "#747474",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoidLine);
export default __webpack_public_path__ + "static/media/VoidLine.554a400c.svg";
export { ForwardRef as ReactComponent };